<template>
  <div>
    <LHeaderRooms>
      <LNav />
    </LHeaderRooms>
    <section class="container-fluid">
      <div class="row">
        <div class="col-12 top">
          <h3>Номерной фонд</h3>
        </div>
      </div>
      <div class="row">
        <div class="container">
          <div class="row">
            <div class="col-12 item show" v-for="item in rooms" :key="item._id" :ref="item._id" :id="item._id">
              <div class="row content">
                <div class="col-12 col-xl-4 z-index-4">
                  <div class="gallery__rooms">
                    <div class="main__photo">
                      <a :data-fancybox="`gallery${item._id}`"
                        :href="'https://cdn.a-it.org/insecure/rs:auto:1920:1080/q:80/plain/' + `${item.photo.originalUrl}${item.photo.name}`">
                        <img style="position:relative"
                          :imgproxy-src="`${item.photo.originalUrl}${item.photo.name}`"
                          :imgproxy-width="1920 / 2" :imgproxy-height="1080 / 2" :imgproxy-quality="80"
                          :imgproxy-format="webp" imgproxy-resize="cover" class="main__img object-cover" />
                      </a>
                    </div>
                    <div class="gallery__content">
                      <div v-for="photo in item.photos" :key="photo._id">
                        <a :data-fancybox="`gallery${item._id}`"
                          :href="'https://cdn.a-it.org/insecure/rs:auto:1920:1080/q:80/plain/' + `${photo.originalUrl}${photo.name}`">
                          <img style="position:relative"
                            :imgproxy-src="`${photo.originalUrl}${photo.name}`"
                            :imgproxy-width="1920 / 2" :imgproxy-height="1080 / 2" :imgproxy-quality="80"
                            :imgproxy-format="webp" imgproxy-resize="cover" class="object-cover" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-8 info">
                  <div class="row">
                    <h4>{{ item.name }}</h4>
                    <div class="col-12 p-t-50">
                      <div class="row">
                        <div class="col-12 col-xl-6">
                          <h6>Площадь номера</h6>
                          <p>
                            <b>{{ item.area }}</b> м2
                          </p>
                        </div>
                        <div class="col-12 col-xl-6">
                          <h6>Цена</h6>
                          <p>
                            <b>{{ item.price }}</b> RUB/сутки
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12 col-xl-6">
                          <h6>Спальные места</h6>
                          <p>{{ item.capacity }}</p>
                        </div>
                        <div class="col-12 col-xl-6">
                          <h6>Расположение</h6>
                          <p>{{ item.corpus }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="buttons">
                      <div class="order">
                        <button @click="orderRoom(item._id)">
                          Забронировать
                        </button>
                      </div>
                    </div>
                    <div class="col-12 add pl-0">
                      <div class="col-12">
                        <p>{{ item.description }}</p>
                      </div>


                      <div class="col-12 icons">
                        <div v-for="name in Object.keys(item.info)" :key="name">
                          <LIcon :name="name" v-if="item.info[name]"> </LIcon>
                        </div>
                      </div>
                      <!-- <ul class="col-12 last">
                        <li v-if="item.place_price != 0" class="text">
                          Дополнительное место -
                          {{ item.place_price }} RUB/сутки
                        </li>
                        <li v-else class="text">
                          Дополнительных мест в номере не предусмотрено
                        </li>
                        <li v-if="!item.info.breakfast" class="text">
                          Завтрак — 300 рублей с человека (в стоимость не
                          включен)
                        </li>
                      </ul> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="borders b-d-left b-d-right b-d-bottom b-d-top"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <LFooter />
    <LCreateOrder :show="showPopup" @close="closePopup"></LCreateOrder>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// SEO optimization
useHead({
  title: 'Номера отеля LEON - Комфортные номера в Сухуме, Абхазия',
  meta: [
    {
      name: 'description',
      content: 'Комфортные номера отеля LEON в Сухуме. Все удобства для проживания: кондиционер, Wi-Fi, мини-бар, сейф, ванная комната. Номера с видом на море и город.'
    },
    {
      name: 'keywords',
      content: 'номера отеля, отель леон, номера в сухуме, бронирование номеров, размещение, люкс, стандарт, комфортные номера, отдых в абхазии'
    },
    {
      property: 'og:title',
      content: 'Номера отеля LEON - Комфортные номера в Сухуме, Абхазия'
    },
    {
      property: 'og:description',
      content: 'Комфортные номера отеля LEON в Сухуме. Все удобства для проживания: кондиционер, Wi-Fi, мини-бар, сейф, ванная комната. Номера с видом на море и город.'
    },
    {
      property: 'og:type',
      content: 'website'
    },
    {
      property: 'og:image',
      content: '/img/room-main.jpg'
    },
    {
      property: 'og:url',
      content: 'https://leonhotel.ru/rooms'
    }
  ]
})

definePageMeta({
  layout: 'default'
})

import { ref, onMounted } from 'vue'
import { Fancybox } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css"

// Define async data
const { data: rooms } = useLazyAsyncData('rooms', () =>
  $fetch('https://api.leonhotel.ru/api/v1/rooms'),
  { default: () => [] }
)

const roomToOrder = ref("")
const ordersStore = useOrdersStore()
const showPopup = ref(false)

const orderRoom = (_id) => {
  ordersStore.setRoom(_id)
  showPopup.value = true
}

const closePopup = () => {
  showPopup.value = false
}

// Lifecycle hooks
onMounted(() => {
  Fancybox.bind("[data-fancybox]", {
    hideScrollbar: false
  })
})
</script>

<style lang="scss" scoped>
.icons {
  display: flex;
  flex-direction: row;
  margin: 0
}

.property {
  position: absolute;
  width: auto;
  height: 20px;
  background: #ffffff;
  border: 0.4px solid #707070;
}

.gallery__rooms {
  position: relative;
  width: 500px;
  padding-bottom: 16px;
  top: -4px;
  margin-left: -13px;
  margin-right: -15px;
  background-color: #fff;
  // float: left;
}

.main__img {
  width: 500px;
  height: 285px;
}

.main__photo {
  margin-bottom: 10px;
}

.gallery__content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
}

.b-d-left {
  border-left: 2px solid #d9ccaf !important;
}

.b-d-right {
  border-right: 2px solid #d9ccaf !important;
}

.b-d-bottom {
  border-bottom: 2px solid #d9ccaf !important;
}

.b-d-top {
  border-top: 2px solid #d9ccaf !important;
}

.content {
  position: relative;
  z-index: 2;
}

.modal {
  position: absolute;
  bottom: 0;
  z-index: 19999;
}

.top h3 {
  margin: auto;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  font-family: "playfair";
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
}

.item {
  margin-bottom: 52px;
}

.main-img img {
  height: 305px;
  width: 502px;
}

.little-imgs {
  display: none;
}

.show .little-imgs {
  display: inline-block;
}

.little-imgs {
  margin-bottom: 35px;
  margin-left: -25px;
  margin-right: -17px;
  margin-top: -16px;
  justify-content: space-between;
  background-color: white;
  padding-bottom: 16px;
  position: relative;
}

.imgs-container {
  width: 118px;
  height: 78px;
  margin-top: 10px;
  float: left;
  margin-left: 10px;
}

.content {
  position: relative;
  padding-bottom: 25px;
}

.container .row .col-12 {
  position: relative;
  // z-index: 2;
}

.container .row .col-12 .borders {
  position: absolute;
  left: 25px;
  right: 25px;
  bottom: 0;
  top: 11px;
  z-index: 1;
}

.col-xl-4 {
  width: 502px;
  max-width: 502px;
  flex: 0 0 502px;
}

.col-xl-8.info {
  width: 868px;
  max-width: 868px;
  flex: 0 0 868px;
}

.main-img {
  width: 502px;
  height: 349px;
  padding-bottom: 16px;
  margin-left: -15px;
  margin-right: -15px;
  // background-color: white;
}

.img-container {
  margin-right: -16px;
  margin-bottom: -16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
  // background-color: white;
}

h4 {
  font-family: "Lato";
  font-size: 24px;
  font-weight: 300 !important;
  font-style: normal !important;
  margin: 0;
  padding-left: 28px;
  padding-right: 16px;
  margin-bottom: 40px;
  background-color: white;
  text-transform: uppercase;
  margin-top: -4px;
}

.info h6 {
  font-family: "Lato";
  font-weight: 400 !important;
  font-style: normal !important;
  margin: 0;
  padding: 0;
  font-size: 18px;
  line-height: 29px;
}

.info p {
  font-family: "Lato";
  font-weight: 300 !important;
  font-style: normal !important;
  margin: 0;
  padding: 0;
  margin-top: 2px;
  font-size: 16px;
}

.info b {
  font-size: 26px;
  font-style: normal !important;
  font-weight: 300 !important;
}

.buttons button {
  border: none;
  background-color: transparent;
  font-family: "lato";
  outline: none !important;
  padding-left: 0;
  padding-right: 0;
  z-index: 3;
}

.buttons button:hover {
  cursor: pointer;
}

.buttons div.more {
  position: absolute;
  left: 30px;
  top: 276px;
  font-size: 16px;
  z-index: 3;
}

.buttons div.order {
  position: absolute;
  right: 0;
  top: 246px;
  padding-top: 16px;
  padding-bottom: 16px;
  height: 78px;
  width: 200px;
  background-color: white;

  text-align: center;
  z-index: 3;
}

.buttons div.order button {
  height: 100%;
  width: 100%;
  background-color: #d9ccaf;
  font-size: 16px;
}

.info .add p {
  font-family: "Lato";
  font-weight: 400 !important;
  font-style: normal !important;
  margin: 0;
  padding: 0;
  margin-top: 87px;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 20px;
  padding-right: 20px;
  text-align: justify;
}

ul.last li {
  list-style-type: disc;
  list-style-position: inside;
  font-family: "Lato";
  font-weight: 400 !important;
  font-style: normal !important;
  margin: 0;
  font-size: 18px;
  line-height: 25px;
  padding-right: 15px;
}

.add .icons {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.add .last {
  margin: 0;
}

.add .icons li {
  display: inline-block;
  position: relative;
}

.add .icons img {
  height: 26px;
  margin-right: 20px;
}

.add {
  display: none !important;
}

@media screen and (min-width: 1200px) {
  .show .add {
    display: block !important;
    padding-top: 22px;
  }
}

.popup {
  display: flex;
  background-color: rgba(0, 0, 0, 0.58);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
}

.popup .form {
  width: 1170px;
  height: 520px;
  background-color: white;
  margin: auto;
  position: relative;
  display: flex;
  padding-left: 57px;
  padding-right: 57px;
  padding-top: 57px;
  padding-bottom: 57px;
  z-index: 3 !important;
}

.popup .form .borders {
  position: absolute;
  left: 55px;
  right: 55px;
  top: 55px;
  bottom: 55px;
}

.popup .form .content {
  position: relative;
  width: 100%;
  max-width: 100%;
  flex: (0, 0, 100%);
}

.container .row .col-12.info {
  margin-left: auto;
  margin-right: auto;
}

.popup .form .content .h {
  text-transform: uppercase;
  font-family: "Lato";
  font-size: 22px;
  text-align: center;
  margin-top: 38px;
  margin-bottom: 4px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  top: -12px;
}

.popup .form .content form {
  width: 790px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.popup .form .content form div {
  max-width: 340px;
  flex: 0 0 340px;
  z-index: 3;
}

.mdl-textfield {
  padding: 0px;
  padding-top: 20px;
  margin-top: 15px;
  z-index: 5;
}

.popup .form .content form .mdl-textfield .mdl-textfield__input {
  border: 1px solid #707070 !important;
  margin-top: 0px !important;
  height: 55px;
}

.popup .form .content form .mdl-textfield .mdl-textfield__label {
  color: black !important;
  font-family: "Lato" !important;
  font-size: 20px !important;
  top: -14px !important;
  max-height: 34px;
}

.popup .form .content form .mdl-textfield .mdl-textfield__button {
  color: black !important;
  font-family: "Lato" !important;
  font-size: 20px !important;
  max-height: 55px;
  height: 55px;
  max-width: 100%;
  width: 100%;
  background-color: #d9ccaf;
  margin-top: 20px;
}

.popup .close-popup {
  position: absolute;
  right: 75px;
  top: 50px;
  font-size: 50px;
  color: white;
  background-image: url("/img/icons/close.svg");
  background-size: cover;
  cursor: pointer;
  height: 38px;
  width: 38px;
}

.popup .logo {
  position: absolute;
  left: 39px;
  top: -35px;
  height: 70px;
  background-color: white;
  padding-left: 16px;
  padding-right: 16px;
}

.popup .logo img {
  height: 100%;
  filter: invert(1);
}

@media screen and (min-width: 1500px) {
  .info .col-xl-6 {
    max-width: 320px;
    flex: 0 0 320px;
    padding: 0;
  }

  .info .col-xl-6:first-child {
    padding-left: 0;
    margin-left: 30px;
  }

  .p-t-50 {
    padding-top: 0px;
  }

  .info .col-12 .col-12 {
    margin-top: 20px;
  }

  .add .icons {
    padding-left: 33px;
  }

  .info .add p {
    padding-left: 17px;
  }

  ul.last li {
    padding-left: 24px;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1200px) {
  .col-xl-4 {
    width: 380px;
    max-width: 380px;
    flex: 0 0 380px;
  }

  .col-xl-8.info {
    width: 760px;
    max-width: 760px;
    flex: 0 0 760px;
  }
}

@media screen and (max-width: 1499px) {
  .gallery__rooms {
    width: 380px;
  }

  .main__img {
    width: 378px;
    height: 290px;
  }

  .main__photo {
    margin-bottom: 10px;
  }

  .gallery__content {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 10px;
    grid-column-gap: 10px;
  }

  .info .add p {
    margin-top: 118px;
    padding-right: 35px;
  }

  .pl-0 {
    padding-left: 0;
  }

  h4 {
    padding-left: 18px;
  }
}

@media screen and (max-width: 1199px) {
  .gallery__rooms {
    width: 100%;
    margin-left: -5px;
  }

  .main__img {
    width: 100%;
    height: auto;
  }

  .main__photo {
    margin-bottom: 0px;
  }

  .gallery__content {
    display: none;
  }

  .container .row .col-12.info {
    max-width: 100vw;
    padding-bottom: 46px;
    margin-top: 48px;
  }

  .info .col-xl-6 {
    max-width: 100%;
    padding-left: 50px;
  }

  .info .col-xl-6 {
    margin-top: 22px;
  }

  .little-imgs {
    display: none;
  }

  .buttons div.more {
    position: absolute;
    left: auto;
    right: -130px;
    top: auto;
    bottom: -30px;
    font-size: 16px;
    // z-index: 3;
    display: none;
  }

  h4 {
    font-family: "Lato";
    font-size: 28px;
    font-weight: 300 !important;
    font-style: normal !important;
    margin: 0;
    padding-left: 31px;
    padding-right: 31px;
    background-color: white;
    text-transform: uppercase;
    margin-top: -43px;

    padding-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .buttons div.order {
    position: absolute;
    right: 0;
    top: auto;
    bottom: -25px;
    left: 0;
    margin: auto;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 25px;
    padding-right: 25px;
    height: 46px;
    width: 50%;
    background-color: white;
    text-align: center;
    // z-index: 3;
  }

  .main-img img {
    height: auto !important;
    width: 100vw !important;
  }

  .main-img {
    height: auto !important;
    width: 100vw !important;
  }

  .col-xl-4 {
    width: 100%;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    padding: 0 !important;
    margin-bottom: -5px;

    .gallery_wrapper {
      position: absolute;
      width: 100%;
      margin: 0 !important;

      .my-gallery {
        width: 100%;
        position: relative;

        figure {
          margin: 0 !important;
          width: 100%;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  h4 {
    font-size: 24px;
    padding-top: 0;
  }

  .gallery__rooms {
    margin-right: 0;
    margin-left: 0;
  }

  .container .row .col-12.info {
    max-width: 100vw;
    padding-bottom: 46px;
    margin-top: 48px;
  }
}

@media screen and (max-width: 1000px) {
  h4 {
    font-size: 22px;
  }
}

@media screen and (max-width: 550px) {
  .buttons div.order {
    width: 100%;
  }

  .info h6 {
    font-size: 16px;
  }

  .info p {
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.z-index-4 {
  z-index: 4;
}

.pswp {
  z-index: 9999;
}

.gallery_wrapper {
  z-index: 2;
  width: 512px;
  padding-bottom: 16px;
  margin-left: -15px;
  margin-right: -15px;
  background-color: white;
  float: left;

  figure {
    margin: 0;
    float: left;

    img {
      margin-bottom: 10px;
      margin-left: 10px;
    }
  }
}

.pswp {
  &__bg {
    background: #fff;
  }

  &__top-bar {
    background-color: rgba(255, 255, 255, 1) !important;
  }

  &__caption {
    background-color: rgba(255, 255, 255, 1) !important;

    &__center {
      color: black;
    }
  }

  &__counter {
    color: black;
  }

  .pswp__button.pswp__button--close {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAAAAACPAi4CAAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAD/h4/MvwAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+QGGgcIJXd3+aUAAABedEVYdFJhdyBwcm9maWxlIHR5cGUgOGJpbQAKOGJpbQogICAgICAyOAozODQyNDk0ZDAzZWQwMDAwMDAwMDAwMTAwMDQ4MDAwMDAwMDEwMDAxMDA0ODAwMDAwMDAxMDAwMQoYv+68AAAuBXpUWHRSYXcgcHJvZmlsZSB0eXBlIHhtcAAAeNrtnVmS40iSRP/9FHUEAL4BxwEJ4K9F5nOOP/rUQRJkkAxGVnVPpkh3VmdERoCAL7aoqZk5wv/+63/CX3/91Y997kI8x62OtSt9ieVUck1DV4aSSy1TWeMyDOt2Op22YdDPp5L4Sa4xpyV2aaldirp2LFNIY52rPphjndOaU9FX3TBGfWgY4hbXbo7nOsa5jkUfLAsPK/3Q8e9yLmuN/C7wBI0mlY1xxLn94nq5R3K7jX524hPp+omhy2NaNLWBwW3VP4p5WGMZFo2njzFW/aTGST/rY46Tvi9xHM766RA7/awMm76O+ruPfRgWf2jWL5P+TlEjePgzML32vSY5aCwlznlIKZXbBINn2H7JJMea9KeLsya1Vf9vWKsuGlaPu/r5E388nkF/D/p7Ce0mw1Jj1S6xLnXU5LRS/P42lscRaTiZuerfE2sXtKVbWTXE/QIt/KBna6kZoeY5f5nq/ue4a0U3ik+m1OlGQznfpqOHRP2d9cHMjjJ2jVnTZCvY2/DZE9vmf32kl2BFfMIuDavkeiuLRjNqlbr9WR3P+uxRoT1LD5n0w/rume8fGXQpa+DbfP78/fGLNG5/dPj5s3Xlwk/vHxrePDXWlLED5ZMJh1dPxVJUiZou2rhdjZauQdfndnsE9jam8HYlNKaUa2nC+X5M4fVKvBsTt29ieRlX+ED8J3131i00Pt2mlz5K3h/HGN7t1vNbPBfW92vUPTcvzx4d9vXxR/ZnxR8Ipj8nU7yEH6jE/qHj42726m5q8Yy50PIWm4+FVYmr1aeXe9LuFcYgVxXPzbTcrg3t4mcTudxWSzzp/7JEz6/bR3Qwnr12KL27+NHc6ubTZc2C/9mXtZkQ2+uEAmikmRuzDpK+LI3QdI63uH9keHza7eJ3I7yt0WXi4dXMcdM2r3PCU+SLOGZ2cyvnuB69bZrCU9mV95WnvHhUedxhzAYVfFSuLg6Tx354VHj2rI9HmFNqX+Ma9qdOct0dfp9/5WRvihvn7ywFP+FV9X0Xu8extJuG412/GclSWOBJ0j3dPnMZSPgyknoYScrz3fOf3qo9Prx5vhFSaR/ov47hfgjh49V4eeNvRqQ9HCt+fijYApk4mY1/s675X8HGqa9Dxc3sxt7I9cHcf8VKDyP6Oq0rDpgr0qx/ltFLnIWrrqv2eFVol303nVePEsLOuk0tY2BVXj/tduF3q/d2avcmN825S1rGpw8s4XjpL09wss3GrMdVvmEq8iMxpT71uddcT3nWKIQh9ROwvsCJfhP9r4mrUtL1Neu7GgN7rhUoJWnQk+KQ3l/1NAHypSp44SPSul4RyjnJnCH7vs3lz8DfwU+4/NETBxnnOuqjJ8Z1fXbfxsnH5M9OHrfiEkniCXyTZllI/UgPPj4Dn1t4ztQ+Whh+5skaf/a/pUF81a3kH7QQCrMwTkCg6l/UdNaU+rKlk3+ur4cxJk9j4QpNfv+qh+hr0OzZ1D6OafOFC5bOTwFkjbrZkKq+StAU241x1HJ+/VqDbjKmQZdHLaTuHLs87dOY2IYsoCdrobDi9sHDGK+3Ci+f8cOvH95I8jK2fc3I03DZY6+VxjyUcNts79LgTV74yse5WJJ1E4HRv29T32/V/oTjtutXxc/Q6uxSM8pVShTbHrYPliasDze8uxF/HgSy50be4iY3UTeJGfE47+OJbQ7BUsOFcb+wyYrHVFbJStMyJttWpngBpjpKQArWIMllpEwEGdlwyao1uiAM8vRcWCbJ2HAbY5YfSaOuWPRb6bw2QIG5QlhJj+SonHNfpeWS+lPt06lOeYoxAyTWzC6tivVL2iAYZOh45pxGiWuKijQ19inNZQsavJREF1Q9Y8RsIH5V5kKiqTnpZkVLPcg9TJr9hh7cxhj7tMk/d3kOecTvgdrkNBRh64mjEMmUdeMI4oU1WYhgizkRGS/GO0RcpWBO1HOzrgoRUzQK8J7kqaL0LUstJsnOWCYsYDppLeSmNC1NYJAYaKI5R6HDM65L1y55PghkJUyXXY7AlFXxzAkonE4aAp63OLrv9QdQJkgWtcVly20nJRLBUoCAoe+2NlgXfY3NYGhCuwRrBbOFQwZD5nDx1cVKrU0IGr5Wo3qxZTam20KCDzEQkpxFuzTo81gIFqUkDL5WRZ+QXZe9GSSQeC0ttSaujZfX1GJi3rRFCAEfFhjTQyQt3nwJCQbwute66axd0/PscmV7oTu063GUNElqBDoRte6w2d1wyl1tYqJFl3DIDLLyuQsSCoUKme0u2oUhj4LPPVsq+KTfZUgpYKrEo4I8ZC8jYF4m/ygEoUnBD4XgOkaJg8C6xleDVuUsoZh4MuSKIMwqUZS3tsJs+huRlKKgPrpGIqCtn8DlVQ+ueJxmj7Qv6Woy8sWsSZN45sRO66OgPI3x1XdHC/n2wu+/C3/nw8fvwuMPD9bnRzcM/8Ro+C58f+FhjG+uC//EaH55sW9jfLPYv/rdP7TYB4H8xdvI40k/+2ELMkyLYEKVgcAxyVAkouZk/9HJWSu8wBUQYEjPpUTERwV/28k0n4DQWAztmox5lH4neBHd/2Z9aoQ1GSCdZCk7+ZpZiltxTAnriH8mapJaxhikv5MBpWGmLhGKloeQuze7BZjZNI4Khk6wI1u17sv8D/ZzcpsydTHIvOKku0oYmmRANSDdIGs6mg0h+sH6KFSXgY0mzojoNFj96fhOkq35DowLSyx7BMbWxD2WUyUXoHXbl7jffy4LpO80Zo1Pa5jkuII/SthSZEx1Ey6XbZxksE6kEgr+YxLeOGFH9VHFCEfoIwu54tADfltGFrM/VjllLa8GKzc5234v8BRw3HFiHHJ72hoMskBHkS2Ve4e+wkLOEgC+lffX1p/0/GL/XvD72G6t32TMpiWFuYdYLBD0gvNetZSmo8uG7WFMnaRJZrYSVAkflQVvot0a5eVGjVLWGJ8mIL9lAgiFExq5RgSo6ggG8KRlJvFiATh5XTLff/JdePzhYSF/cJsqM6JtTGft0NzmS8JHQFqGNpJLkibgEpFiUg5E49qck1nCnlkgpVWeULsWAZaDwrwEMDaWrHxEIqBYFzB7VZpxOCHtpKDMassjImD6Sw6yy0QxzjBYM8/eMTloe3jJI7BB7pHdnKVIo8aajAm2YnUCdslma7eEPnI04hHaMCJJmvnKz/xvDaBgNuLN+nw1PgfDpkcLyEgQk1bBsiwRHJESjXABNgs+JFCsxwHLLTlBLyVnfZAortJ4iVxkktAqG8Pnpw5ghIoi5kJIsdgG7Nk3GTV9X9FSCfRNICXyWA8wB5ikGYvanpcrkq8NEGYCNJeZx+gq9NvmUIZN8GrFSCl8qdo7wKiUTdMSGB1QSlkdqYSWlP+wrf8Rl531ozF25u9KgvU8S6sG4SQtI7k9yAWNKwkSJoeCMm7SvgJZZCi2ydQKWwvVSwZ7Y2l2ZETOZWcKlvCAc4XNND9EUjZbaLJDxQ3cZSHR9AQSk0QL2ime1pj0axk27dus8WLQANiboZj2SwaEpF6H7MuwzFeXjUGDfDeexM7LMwh7I6Yjpl0LL1NC+KfRdOUwRrZBEF8fJMxabYl6D7NNCQ8jRdDKSORytO+asI9aghJtoxK5EkgzTRYxkT3Sj8DPikGk1QgcFm/3F/JnQPQk3TcLVxyE4tIiNmv15mya9k0gMaAR2yeriKcoBKMMHXJcURHRrFZpRuskuFjSRWtIEFgle5vWKGIf5QAky1HSPFk+enKOzfWkbKhMuNChuvsNEAgEZ8IXpimkk+wRtxgA5/VoISu7YyVhxg6FtQXwTEQFvTYiMQ8JjHwJkj1CLkkpZedYWFI9nlax8ixXyznjSIuNuoRR8Qf5dZkbllMRZIHFwnDYo2m3oFN0qbCI1gRHWY5YXFZR08sIMdIGJhkAIo6yK8l5KS3OhZhNuo2ArLqxogwiROQ9D1djX1jBSiK/WSMZ4YCGyQ5pKfXdarREuhcZI/Yn5oZbzoxF62HffxBI3ZrHSI4kPWy4boU0SSyH2PQNalAihOFrjtn4Q4uLjzANLSckYDTguOUgHTdLzyILzP1HWVy2fK5EkMVUFLIDA/jSqx0t5IeOcP8uIhjEj1J5zSWdA8ImYZzkI+RyWB3wl8TtzFgVK6IiwmX4OcOd3itHGQZGRNZbm6G1DXaD1i5KK+IhYNDsJUmCPJomcT6KABWbCCXwvgoVtdMLgiUHqQ8tzWrrGTbO0v7JzH8mytbinozdogAQa4jMJseam5NXBYXWjbTm2nh8lH40KkwfEpk0OCUhS/nau6BGe3nOUAzNaQ7O/kJKnZ0VTS7skGnADvdUktgSKbaFZZCBkbTbikr6sUNauQ4ULlOiccp+6rGhqWVGyyWxMp/yZxgrKE5LktCAdkd6a2wQ0/nIQ5pzIlWXg2mKE/DPqF/mHYolU2ohvYFlYApy1Ivm7unU+PW7NNplg4QScAGziUmZwZNAcVRZxmTIbEFJ8CCZPL/LPkikSZJkFc7HKHt09ro2A6JJzeBIfEmxhLGPGTKKQUito/NMKfs/GZ4A/mBzJUsk407N/pTNJkvLnIlRzinvmAAmgNyRZq/xLqyqJiahDVo5WA+ZTdlhrcfRHTrfPtsFRfyeCTsig8HMoLyEnZkQucxIbVi5P8ixBilzZ4HLyPEMioQKS+DfvhmOlHGmWohNNkDGJWQbWuBMxPlAiUkuqmMKrVI+BgwaD/FBAvnbH8s4A5K0DauiI0VAaNvZvgN7vFjOWXQocmElXUq4N8tGo9zNTa33NiH8DJZ7ZQ7kPQ4iI7gzRJR+hSnXBk9sqQknBQsopxZzxL8InZwQOzCLLSpZt2QiaJP9XR2KSstZkEUA5mTykjhRFgEAg89AdmQbsADQUmfCHrNfGBVwLyD4YCHlmxLYS5rPJNg6jQIfgvOMAD/tHzEBCQI8LUhAzgzzJ7/GdsoCZohCRK2YpYpcpIV1KngGojtXJNX2OE13tkKi3COoUWAU9NobHhR7qgN/JtEgUGA6kZijJTIBeslxiVxGIZ7S9afg4HlsJsoJen1MdniGjUQtZJviJ3D0DtVqRc4ABMaWgZwrm3Bw2YJ7AL5ITgsHKgBuylrKRSkD+VAhIOm+N9juOrPZ4DitRTEpD3OMXUAw5HUaoAcLo9QENbLMstkDY8qOJC3hrBjCt+Ln2XZLMqZMzufOZROWnInXiJuTTDrx/2aDogg2wU1gv1eAQqJKxNx7RbmpGKFYT+aHcEITlbGRqSVkkUhCPQNpEBMIC3As3l26yNS0ZhL0gY9iJXS9xbewNeVoIbVvxIzkFpKT3ZIUqerJewgqcE1iwRDLYWbqL0bpH3OAwZ3Cc2P+wXcFksYg3mxtwCbDL5TBkdtBIEFIunp2GApb3CVH+oxNHhjrvGJTHP2fQwTVzuQViC0EyLMdj9TUkjWZRcJ1Yxl6s90sIjmcRqhn2Bot9mBUGxktiY1NwDw5VwQQHFC6g0BuWi92Q3ZFczjpE6wltuNEqeeUki31yE5Iv8CQTKQ6F0NEcEZpKSsA4OD9nEslflFMnqg2dcJ31a1AFIW8A8aiIe7XC35Yx+vPwtcLpa4e+k7hCY/pD1CUgLi3YgPla7OqZN6Qu5Dwrri7XjOeybtgSkkCaa+wiKukhoQnIsnK4IWLzVu2LT2zvkeBFDjWupzB0+Rl4P6pBcCim1XCcZNwwLyiCQsCKbPHbg4U6HZy3j03ta+oUF+W73iRMDaYxAqjgJ4jdrRcSTiA42a2ukDFDXyfNE4KiNZcMeRkmmkwDbUR9TpgL7jFr07qE79GgseoBKgF06WbTg4WZY0qmRzZAWJaykiIw85OY1ia0W+J0eBA67bZwgawFF5+DB/4yNtACvoMdk6zoYqgEzQPNBxAKREwTOwP7lJ7KCfQsLdWtpi/hb2oOMoA6IaZwpNkSnRa3CHXU/EY627W5F+E6XStbFM9YkgJ1UCcqxvJOq+SqaHhC8Hdk5Wmj81igjWw0ljC6bVf+QVifPc1MBH8vMMiHAUSBoKVGqwMI+CcIFPT7bCWpKqIZk0uJvAuikN8QIl4Hq39+hEZfZA83iyRWsXYanPZH60R2yC9Yj1w6dGBoP2aQISpPqrGZg9d8qm530XZqaUP0bIYLxAx7XWswIzV2LdQJBaKnbVkh5gR0r2a21PkowtJ1fVQwvANkCtkBQuxOA60caeOhTKM1nfG/uAOD7919nwnPoSpirefSj6Qjn0cmkRis7hgkYyA9EPmRS4pevVY5sb76wYyLQSK2n4CCC8oY5iKOWQtdbUNMILNpn/wuMXurB4sJJETokfqkLSFdCyxuCRQ9S9skb0FLmqCgYCOsvtMdWxxWozPtB/b2mEqza5N3Jr4onl80CJuXfZ8MnKRqiqsYQPITUKEHHPZMl7J1PsgcSCyb5hxeLcVEGS7Xg6B2FFR2kSmE+ORjJpxeZUAQlrohQZ0gnBigTPdEpHwWNy1AA+oG2XTl4IG8S0xjltutNkiwcX3UtZwdhA9kmCVQCZiKKAneYeOfSc1kEzEGjstjePCXCjWhz3FBjgzDKLVylkgs2P0xl1JsPQ8eDPMaHaq966SJlMBoCC6EpETxILoTBaRpiehQsBCup3EMxE+MTZlmydzNlKO4fSj1CFytKcyVse1eKCJYKrdqBBVHWgf53dMRpE8KBDebXolWcN7SNa88zTGTQTQEOcDLsqBBrBVUqmFoXrrRHEFAAVSs9B8wl7IPU4eyRmYk/udglEYSswrhI2wgF7mxoqyjrcoe2kMaYRHU4TBsmp6cACNSoCiknJjM7Ut1VQIdBkT19cAF7PTyivlJS7kWBytWbbTg2yTrDMvsOXG8ZwVe865h2Gv/kePdT4KJNkP3YZ0IcUwm8OK5GIHRbYJ2NMbARi3hZbDcvxeGuGLCaGCxAQPYd/oW2STeL1/xiO2PS5agBsRSgNUROEJ3pwwnVmDp3GJEQrvQE0ZuPcYNfJZxGwG+Q+mNhoZagd1Ywl/wx7E1VqJDWlpX9PsWAFjx0ym7CIQckedi8sVCEc4Y6qZplYmlFu9VkfQ7GoMmG1tw7FEDgmELgsQKiSPvPEM4eyMx5KbkR2hUTExEnEIlpn8KRktKljwPhIIPJyAFhaF9FIrJMGEesNNP90ZMVhtTXqE2sB4uGAIQz3eu2zhlUyVGHQh0esGgiFxkKDiTwhhbgmEarBIFNBdVagGuA77kMm+H+xP5OzsEYFwZINH3AOEtf1uNUGHU4A4FPiCjwvk7XDajQE55rIRxULJECOsZuHbShIynFEe4k6TPhoqqPbszAZhTHKijqgH+LuaRSdGy7DssKFMigYYK896VJ538Rogvtxxpdm5kwkCyvk+REYKC6lPYSXrTlHn4Ex/qS15gU+R2KFYFFs1f2+mFprK1oudq0aSmhpkcyR2Lbge6pygXAhGEmuE5RopsLIjMM+f0x3t0zyvdm16ibFHgnbnQKc91bxBh7lyGwUBfqEgvUkWRAtpdX4kXxL0BguZ32mxZ0vPaPLN2Jv9lJ0endw3Y3lnIdGP7K6RZJLzqqKMYMBFogGkwHRLfobHSZQ/Ub0UrKK5FQ7kliRsKnqC1mFXwEUO06HwBvIUTidVyla1LVQnJUJR8x6VyL6RlkfaZ6gtBjntscjJiABiwfFJOTkxSlC9BRv3AgxIwC3CZDpVFmQ5m/i139tMfYDXRpJgpq+KHMZysa7BCzlXM447IrSd1nM1obQdiyu0T0QiHkFMzvDwnUzxoBF5BBHSfUUZ2whk6EaPoIcquIwAhutVKBYoEm7GniROJcAavF+dm50o5zOVSJykWED/SuMxyi7w7xKMUInAFqiLxkDsbvoEr2UKemEtCHmwz4iBWbaTUcxSYGxw+HMwGQj8VQxCkbT0DhTV5TZsN8l9T7rcZWpuHsMlMB12OxPqkCEhGablhzeN2WUpxJoCfQl+qZg+jNBbqKMTrZHqQiOiVreC2GmpexcOgHwhzs6mDja8AllrbcFMa54+qr2aXDxw5CG3AoHSJGVonuYZxHJZ8RSoB0lABhtSrNAeBVnnd0j4UudvKh+uOm+Ni9UlFqeLU8SzHPGZ6yXmm+5dfaLMSKO3FpzPxfrw1JwM/drinxuzlwkgyMKT9p9LS3MOTeXDVecN/HQ5VbwdNByyLc2HTx+aaTVGGR+qfeZKLfIWHKk6puf5zgMtYH9JFWVVBHU9MQqoLBIGUuxMDiUjP5KC2aZZQAv2bhIQJ1UwNaneB50OaEnSG13Tjyczu9W5MQbPt+ENwyEtR4EOLdKehkfgCmH8ptfx/E6dQysrL9riQuqmvqdbymnHdZsrbeH70AhX+zQTijRRSXXYbEGXyUoBwh21zHXPu5+A776t7MYeccZw2fxMffHinF6GXAYmW+ySSzcQ0IgSRQgzrRKEgvtGCkVocQhNARrG/rzWsBrCNkPjbGVvpaV0yKRcoVKDhAXsolnRDpIGiOpqluJSHqOCFmJV55spKpCpzbD8NLWPDRW5eCmRnJNRmwo55SlCHAwu9JKfu89l8/tv6iGbXj9V67lFlBflSgqz2CxDL+0N4fiwaxVj6TVdyqnLTasOar0rVYEtOaYOrV/bTb+uJm64+C5DmdxcV/sq14qK9eT76YsViqTE3DrmuAPGqJKktETfOyy8X3QESFWLk52Eos5MnffA4L6F4QQyo37rfWq18e1ht4j4zcWlZoP9+iobNAA34dgqeka5B+aB2Je8Y7IU5Va2UkAj3ovS/AcOCSPvDAOJeLuaQ3sAmW5KVdAx08buRaik6SE5tj0BnRp/9UHV6lGuMbYpXOUazyazpQuR62j83FEUb7kGfg0OcahgPFjIi4SHcjGiEehCLtMrtOAWa9d8HgyEpBd3mbxCpISggtcd7RbY47fJSz7GwCuyvWfgy6ndpNnvFmseLaQvgNUi7Ez0j+6GNCN2kSMNKHsla+G8zebmlHGPOrVrctYIFTTqRaaIxW4SsgNUMjLkIK/u895phUevdWwPuPkvOEf3IwyknPk3k5dwUKswU40Tbmi5Qhv0rrAbyDOkD7JIeIemNBymQHnC6WqTMtS9s7Ruyj+6bFI4u3Wqu6llmq5OwK+Nu5iXqzeLjriu8i0tXKjOgBU1T+ugnp4WbLhxuAxbbjLdKPdPZDoPx6DG0q3IluacxUEhzyHV2Znxo1CXPD/mAsIwO9HZQf1Klot32De/7DD2qN7qsKACaGpVzF9IdzNsom4z/dgf/dudJHmHia3L50j7tGG7A+T5Ln3DU4T3RMXnPEW4ERWNnjgsZGqFHxdMxrOpHbN085Ww3KUgYJPgNAC7vhLBJ4gLKp8pFxjNF88gYq6CqGpeA9GgFxgDiKvI9GU/BFKD2Y/OgRRmAsBwsJDkmUFH2eeSENBQzEw1KclMyhKwXXtIRXMNpsp1P9X80kNI9YywCp8yVneE1SE4vFBX4chdvWOs3iku/i/sdfLJLUNkr8CSGpcg4GA9HFzXTs7OqiSDPBYybXS6ugaulRqGA11RdmyxuuLZ0Es3x/Pu0KtSiN/HuEOvgfoU1yRn+zVnYYwrMPTazhbcoHCflaWUxCFBbDq1PtgjgruDQE4u70Ry5hxvYR4pDrK71yiv4lPCHualvZ622GhMCGNrXqAuwRhIgLQVpLrgsmWSCrktyp8VQggjnsxfIx2tGH4mTX5hsWN6jiHvLZSC42OMcYssfh5YhOeRxfvA4q6udA8xwvsY4/PAIrwgCp4EFoyBcphiFktu4MAx3QlkCz0bRv0UojbHKVvfBVexNM/5kma645ZeuO7wGHDe5WC/hJ6vXXe4+O6j636p7SjDaBvfFnpmv3CtZSUr6voM017ILWUnWYaWEodKjv/oDqMTH0gaCQXr2U6qUe3TWLVKfbYWe8jO5ssuGS3RqEh4Z2ZCN6RfmHy3HhE1UiqXoPlWxSJNu4bt4/rV+chWSMKkDZIjHI5EGqcHs3emzh/7XDZKCAtFFC6TA1a0mqxEUt8NFzsr50xOYyJWN+PQVGUOuVnIdGrMMX+7uKJlciBqGmlNsxOuI94X6O78NUYBcHvlrwGDZEunKw19yeSsxCfoS3RPzWyDRQn5GU6/0Cm6wuAwMQKaHH2jAQe6R2ikVMlQlqYoNOeHh4WMdwu5Gs36NA/6DQhMKYZt/RokgmXBpJVUIQRXfcqPmQkpMvwnggwX7CoI3esylkt2tgwXy1kuZOdONoYL2/iGY3xo8jIy4CQSkFTLTmZ8PyVwo80ZKYGLOZvcoiLLp2UfUm8f+jbeDV8D3gtkcZ6Pk9g6TC5UXXGX3bEekhZr5yEo9TR4uWOvLyHv6zh3oFODvYs+heiErp3pHnLBAD3EZ/fPAD9b6aLhtpadAw2iy1JrbNuytdDPeYC7Jq/5vpswu2AB2MmRathJWEBAKvpVkK+BDhvfvReGdKWYrDZUqr0o4ACxtzMmPrwkdRwV1D3RSQ30hFW7JDoDSR0v59gyncdMTTJ/4xGse3onO8lK4Ecuy0lW+pHTSZLt4qDaDtl4TOpkWlEmVtHlXyipDxXIzSqRhD63nE4A/+Mx8bFO6ix1rzS6JHWO/SqvAVf4WnnRWqSYbFrbBrsryr0kULzuEqNFE/6/uKSwo3edznYoyeKCE8ATBmWiFyoDZ3IrZXLHCliqfOk6dAlGgEmjNQcxlGPqXTa/uKFTxg3Jdpaf4iZXDg9kTCt768Ae8GrkEpzyar0Pw5MO7Ir8gCpNzO0lD6isW3nKpeThSPuQghrLajt5rX5AeVJvc9dylaj0Q/HDrcfv0Ut4wXNx5x+9feQEKTVDXU8uveB8P7epJvdPIsyhVX9Yf5zKvMuCjMhTjpfijzw/9b4GaYHyEbvEFdQR4Rq7Jn4gMV86oQZUbTdOgkaUDPZ1WhE8SVo9UDRJZV/ck5Uor2Wqv3RFHRvRJLTUHS2UzADJ6AGGH9GN7F5or61mO0caKqi453CL2BqEWg8UYT1Bj8K8VgQ/2M9ephk+Ljg1ZPYCHGsCWmWwPAxEFAWvZxlRZk3cMbqLOLuknIMBstWT1kHkanJLMcUoFDVoCQjD2vbDwhDukr+Tldaq3Mq8THCk6A6WS5mXT88jZ4RuUcFa7qp9YBtmhkK/YzNq7rOd9zqXFRTpCnGq71Zn5TpyfxQNK/CjmEq6w0EhcyJ+HM1JaEd8KBnI8QypQROuHkWdfqtQnr4pY3wgdD/AS8kINFDsQdx+Vx64Vnh0adW1KHCVyG8oC4bkUhOIA7jUBAbbxtk2W9it5e+h5skrZ2fTjjiXhcBVp+qiuN6hGaKhqWXH1pz21rv0dnYdCa0SNMW5bzXtFT90iF6ySahVpm8kG+wg2fQUDniC1jnjBXdrghsirO3V4HkgCavx5mP5GYtAAB3qbuIhB36tv79yXquj7B4TX8zSulsF0se9fBJHjqJxgbXxydma70JLDKBbipCm+75sTg5xnZ3PsuWMSXfQNWAea2tUSq6oT62yXWh4lusAj+dgVNG7hieT06+j8+wzBadwJvBqHMuKa6eo270bsFcdtUegSFAJNRGGNbdS5WOUnRo7O8jn3oqWie+1xLeaZVN4XWDG90XL1O4bV9Nk8cHJHq+OdyBiBHjRtUpt73w3Rs4mIdSiQcVMJBYd+i5wQAuECyALgp6TenSzk4MZZJbKCFA+ItulvWyJwAo7j3yjRITr2Sec9e7mlQqgQ+ALTContfjUk1haKopKseFoxembqSQ9C0fxurXOLXbAq71JOeYW4bq0sUnY4s5D50ILO7a5sK+xumcsZI+ptIjNFL5z1BWzph02ct4hELe0FhzqWZ+RwQeB/LTjAGIOJIlNj/idObsbL/jJaBqHTY2uT+MCsPbiBspq60CJBciNMsLZPYfjvuyuIqtk/MypD27IicMRjBP8JhOd7knGx1LF6sNB0Xmke6Q+GvY7QJIQPepSejEJlCmdjiZ0VoulEQDq4ybrVljJZFNqY0XixuCD2WabmOL+Z3PF1NsBtSCdjodNuRYJdEBeglQ5JPnJtTVIp791oTTN3q2Bcp+YMCuly5RPu2ihdYskt1kMHA4Wq48wJsomjDONS6P0yMFY7BCV5H+jhQFiZw8TOOV0Mq5sbUwLJGLipL+9jYleSI1mc8IzhdbHxHaSXrm0MVHkiqwDQvekEyo5JyOQ1ltLMZoL5ddHgYSrOpFDckpgLaNPgOJMPVClWS7AD+uIn/PBXRXSpfjcmpr2Enc3JnUGnMPeq2JvQiLANdHue8o+d6y5TvPZVJjMNQUffJGrUwHkr46upmlYdPVWM6uog3k3QBhxHjETxI+ibGwER/IZNbtPdiESI+NAZjtSpT67ore6EWdxO256bB4O34KE97Di2jIcWosi4zFb5jAOggWT5WbvxaUmvbkJoSUftU5YCj/CwSaZsh3O9CVnsLYe1WPLMMt+bLCEhyeCB54eo2y3Wi7AmoViZW/rtdcSbjKOrdXSzbp7q2VrUblrGebMDUhHsqK458E4X0Ffchcx5xqgRVxcXdLociLnj9ny3UpeG4XHu4MCXHuN1CZOYiEP4jQcrWewaloV15LTPEywSm5s9KnbBO+jsxB0DoJ89tJhML0hGftxbdh1I0pJDVDggfeG3TN8d6E1r5zcFkwNy3TkIaNPHfWZMOe9P/RNDUfwBTsAti3y6SW2TJNbcgYSX4QOzolMnHLhTrY5tw6krbXtB2SYgJwfuQI77j1zo6sfH+shIYiRdgpWFoeu8KI0eCc8KqeM9k4g+lA+J1iW5BCHjr46txMk4ELT3tdC/4MPfogOcjKcf6G2GaQafS5LIhindoycGoV71YlnSIaR1O4x3+7jVvB2/d550DoN4e9o8T62vmO4OMKb8m6aTwFAUPmc/u2G2Ng632nxROziXkPL+WruWqXM2vVscKZT9BkormSLji995obz/RstV8cou7qecDb737lNFvS9wKnT70TTNIE56dTs0K+17rV+jn/mHC0fe9JOZWDDz82LHi0kmIkKIJMGc0tBVU/MpXvVROwGH16rT0Bxeylt78slJXA8AaV4XaASC6WE7TyNs4/FA8WN9RLTugYDlopftXNPCIBHQgkfmHroOmzvPCAzsZMv13QsnlYOz0dbZJoEkk89obUt7Yc7WXLpgsBfU+bZOcc025y4RgJeMJiWQ3fWa8nNxPmG6L6JQR7kVlmfRkCm5BBlc+aG23NKgN9w89/QOHyfgDJeT8wiE1hyC3eqq7F81NBOtvYsh9vVKqfEkEgmN02fOofPmFnMlvbWDOREwQL9mmdzf8WdrTR4u1803RXoDq5nmUz6jl7A2A5N8gEdZAkJ1/Eho0sK6JPw+Z4yQRmBHJwDJpBxFFR2VsQpstkBajGm9Mkn4DifNOn0U2rt8livLbhndfYfn2twpH0MebR39I/sW5HNmK5kU1xQTRUMMWbkxIEEwwAGYqML3EJxzzEB0OgT0ZZ2hBOIBWE0So4mG+AFEZQID7n4HIPZuUZYEALjkVM9y5TtGW91pfmQDrK9cO824hNcVgYjvRhYrsYXM/0azihx2LXrn4sDT7OzQ8tk+XCV6Biq55yIE/1W+pXRcrPY2YVMpSGl7CMMyDOek1/PUQ5BTRyM8DhGDXjgxm4aW8adMknG28KO0c371r1rv/Pz8OJzIupl7T0k7BFDLuVaKb/3o9Ogi0LLKfMCGRouWzGHj3kd4E6KCWn7NaoHfLZasYsGBSHMNE20CkgH5bFeWgUpoW6Hg9GB5DZP8s5z8FnVZxoAOVbhrjmp9+nQ1ae0IRYc6YCY9G5bch+uu948wQBPXlzo7cKOCR5Al56hdAvfVXdKcOgHypxeef/m1zj7bPAhONVMDElnn26ADznmssn+1XYstU2alZic4SlQS7B3HJIshMbo0p5DpgspchywDX92IWy+EDIyw9mFe0xQgZ95zdJyQDtvU0prTGqHGNYWn+2npEGu3h2qSo4AJBds1lpi5eRiMwFenCDHTEXCPyozCESoITGP1doqKJD5ZwUyPRRXvO4srAA/ZOxMB20yu3IpZ6QxhJ7YtAbODif2wh4jXAUvCgtIK7n/TTXmpYv1dgSkLWit4+VoweBD3fomjJwqeHCHnDJIV9Hcuo0vpwxybNjxlEFnneRFYqvjqTa1lTJgiPLiduBu7/anxmWg0lFCu5+FaPvkcKfdMNCxjuWUqW0VfD6+iQImGCzZ5qPSXE9uzKR7XU/OscsUrQTIZEIxB8SNU6S8Ev/poh1gnwMFQpjeNQq5tqMOprSfGYUtoPqQ1HLx0V/EgPNxmkQ+7cjHfZqthOk2xtHnM3ccyFWvpz/aweynP5bb6Y97Eex1hwimMSHO87NB5JkgEABR6eyDgVstCLLdXxoGyt4jUWnLb73Y8+040eQ693KXqYmHk0UtVW6U3E8WTWb7OGmUWlEeatYkvezM/O8Juv89Qff/5QTdf+ticzjr8VUp9y+QuLw/4tVLKMLt/RPvXrDz/ft1wqsX7Pz0zSfh8C4MXvA1+51Ya2lv6PG72RJBVU9eNq7GbBzRUa4vetofGj67wbs32LTPh8Rsp/b6Pw397ONUY72+rg2SXiMB/MDWzETnUD4mEihkoPFRPp3Xy/TtrQIuSh18xOTojED2UZeDj+g5vlXEI3gcQHg+gu+n8vi5sA/dlwxeIybgcxp6hwpmrnjbnyPY5Dc0EccNA1U/FCv0+s4N3nHvdXCZLj3Xd+9jefr8r+MOLwbeyJXkA/dgNO7HPX0dd/hs4N+PO7x+/kcLnh1UAI85ZsPSutzeLvgrL+UJT555ezfdXD5bK7wIaRi/7XHyWlVwJm9TxCxzLM6wOKekMQz0k/QuykkeefSKUYXvSt9vn//OnNw+zSvBnmvXo4j2Hu3L0YefDP9u9M9V5LPhx7m8tBXhZ8bita0IT4zFRyN41LnwyYTqB+Y3fLG/H9/gfl3Do9/4qkU3JXqnf1fj79bxdmoe7zZ5v4+Xl5SSUenfrtG7V209V+rw81dtPW5Je9Fj8CtJ42UxYyul9Mpcln5/I+TDdY+PCt8/6zNjYqWl7sKWN7X3sPoMK7j1pZUF8q41yvFpTeF9a4yNimTquqyPnA0tAX+cwg+NyYMcHW9VqxPl66u3v+0vf2t/Q8mc6Bc5vv3t6c0+28HwMBbaXnxCOZLicxlqU8/HNwk+vkgw/OhNgm8eGY7P/LkYRspUOVJlDb5N8kvKHndvv+RyxfvHhJ/B0Nc6GH7Vs76Qo6ez/5EOhldK+FMdDJ+hn+/BT/gG/Xysg+EnU3mng+Gj91F+oIPhw7F8q4PhlRL+VAfDJ8/8RDTCKyX8qQ6Gdzv2k1Aw3C4++s2nNz269C9+OTz70Iv3CM8ujO19TJkPBjciKL5ayP/w0thfucHrt3h2+0Tb5cmvm5IhubfZnN7GO85ZO9LUpac+W6YJB8m7i3dJfnmzF7Cms2HjPe8P76A15U2rSzMxNMb6Fcnr8UH3nwvPPvj4ivRDlJ/uX5J++0T4enF7x3t7uT2b/vh6++cT/MaMfP7nP32j79X2D5raZ+7pD5naTyfzO0/t21jkT5raU9bvT53ah7HInzG1n6nMbz61v6P/v9vUnuKjP3VqHzIRf8bUvo1p/6Sp/URlfvup/br+/4ZT+3tg5vea2ofh+p8xtXcb88dN7XMp+wOm9qsq81tO7Z/R/99jak8Tvp99MJ7jVttr5qOPUU1D1/JLAXqXcrC4xTX8H+bgskP2fdwKAAAC10lEQVRYw+2XvUorQRTH//tl0lgEqzSKClZaiIWCCIIPIZZKvOQFTLq8g421aBGQiPgAGxE1rxC8PoAgGBENQnZ2zj07+5FNsnLjHW/nFLo7c/6/OWfmzOwJSLPhB/CfAdIX3Hz5TwDpeTLreUyAEMHfTvvOde/anX7PmADhEz3VS8sFA9yMwnKp/kTkizEBkg2vtyfBasN2HDv4j8ntawbLcQA8/e0GS5z8hHKA5RN5hzs2brOcGAF49LILmDmblXZxaW1tqagecyaw+8LDfwF41JqB5VjAdLnx0A26ug+N8jRU50xrhIBh/akNm8Nev/gIFyQM++NinReEh06HCRjSH8G0bMxdqs0PU0j6Kg0u52BbJo6GCBjUn8AyLey9kxhMHekJet9TgyeDhDRA0I1jmCYOM7OG+w5hmoZzQyIbIOl5nufAMfUyE1f26JgDxPwzyUyAoBJHyfP36JPWYx94hUppF5DSX8EMRj36tHnBHCauUoQ+QNIWHCy8Rv4NLkP0Jul1gY22UjEkAEEuLxHOIwfYwu/rfYokHp0HVm7fhRRgBxPYTGRNl+KbRPrkNhPUJpvtjAIkPRZgoRGOCGoCVQpzQXpUBZrxSIPNCo9JEEgcqHNws91wIIgnh4oisL7CL5HXkrqzbFhPXIgBHu0jj3K8BT5PmscBE1h/wI/VODaPyvy6n+xVfxdWGHyWgH2eVhFCfSVZG0FnbLgyvAuSOlN8Yu8TO+V4QIj0ydHw6Z7P+lQnXgTE3W3DQPGNUjexktZqUSj9dHkrwjDa8VSIHWvBxmI6dxTBNgx7QB+0RTZtxcEmAJcjW02fkoBQg+OgNqiXtMqm7vcDNEPQXkS+TPS2UTuRvprKv0ZSWfswaR9n7QtF/0rTvlT1r3XtD4v+p03746r/edcvMPRLnOwi6/cXiiz9Mk+/0NQvdUm72FYIvXJfBaL3gyMS6vzkGbf9AL4B8AfMHF/T0wjCMQAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wNi0yNlQwNzowODozNy0wNzowMHjvMKcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDYtMjZUMDc6MDg6MzctMDc6MDAJsogbAAAAFHRFWHRkYzpmb3JtYXQAaW1hZ2UvanBlZ9tg5MUAAAAedEVYdGlsbHVzdHJhdG9yOlN0YXJ0dXBQcm9maWxlAFdlYqtR+HcAAAAkdEVYdHBkZjpQcm9kdWNlcgBBZG9iZSBQREYgbGlicmFyeSAxNS4wMK/mvIAAAAAadEVYdHBkZng6Q3JlYXRvclZlcnNpb24AMjEuMC4w5Pal3QAAACh0RVh0eG1wOkNyZWF0ZURhdGUAMjAxOS0wNi0wMVQxOToyOTo1MiswMjowMOUK44sAAAAzdEVYdHhtcDpDcmVhdG9yVG9vbABBZG9iZSBJbGx1c3RyYXRvciBDQyAyMDE3IChXaW5kb3dzKYl3gosAAAAqdEVYdHhtcDpNZXRhZGF0YURhdGUAMjAxOS0wNi0wMVQxOToyOTo1MiswMjowMG1QjAwAAAAjdEVYdHhtcDpNb2RpZnlEYXRlADIwMTktMDYtMDFUMTc6Mjk6NTRaK/K2uQAAABt0RVh0eG1wTU06RGVyaXZlZEZyb20AcHJvb2Y6cGRmthUt5QAAAD10RVh0eG1wTU06RG9jdW1lbnRJRAB4bXAuZGlkOmViYTVlNTZkLTFkYzQtZGM0Yi04NzYxLTI1YzBkMWZiNjU4NsYa/zgAAAA9dEVYdHhtcE1NOkluc3RhbmNlSUQAeG1wLmlpZDplYmE1ZTU2ZC0xZGM0LWRjNGItODc2MS0yNWMwZDFmYjY1ODawPWgyAAAAPnRFWHR4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQAdXVpZDo2NUU2MzkwNjg2Q0YxMURCQTZFMkQ4ODdDRUFDQjQwN1hO8WkAAAAedEVYdHhtcE1NOlJlbmRpdGlvbkNsYXNzAHByb29mOnBkZoSm34kAAAAASUVORK5CYII=") !important;
    background-size: contain;
    background-position: 50% 50%;
  }

  .pswp__button--arrow--left:before,
  .pswp__button--arrow--right:before {
    background: url("data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBUWdBQUFCWUNBUUFBQUNqQnFFM0FBQUI2a2xFUVZSNEFlM2JzV3BVUVJURzhZa2thbndDYTdHelZvdHNJL2dFZ2s5aDRWdTR5U0xZbU1ZZ2JKcmMzbHJ3WmJKd0MwRk10NGo3RjZZNG9JWnJzWHRneHZ4LzFjMHVmRVg0Y25ibUxDbVNKRW1TSkVtU0pFbVNKUDNYQ0JQdmJKVSs4ZG9XbURGd3lacExCbVlsTkplYnowS3d6eWt3c3VTWUpTTnd5a0VKcmVWMkJhQk1hTElRWjJ4WWNGZ3FEbG13NGF5RS9Gd0wwZERrNFFoNFczN0RBamdxSVQrM0hSYmlnakgraWlrVmR4Z1pTdGd5TjBTdTJzWEllVHdUVCtlc2RwY2JJbGZOQXVaL1R4cmVzRzR6VjhrWVdTWk5pS1VUb2tNTVNXZUl3VE5FbjRmSzJUVzNnUk5nVmtKTHVWa3NST0E5RytiRXZvQVRObEJDYTduWlhFd2R4RVp4enBLUktGaCtic3Y4TG1QRm1oWDFPd2ZJejgxaklSSlE1ZWVxRzlCK3JpUkpraVJKa2lSSmtpUkpraVJKa2lSSlVrdkEvOFJRb0VwS2xKV0lORmtKNjJBbHJFUC9tTkJpYm52Mnl6L0EzdDdVcTNMY3BveFA4Q09qQzFUNXZ4b0FENVZkb0VxZERyZDVRdVcxc3d0VVNhdWVoM3praXVCaXFndEEyT2xrZU1jUC91RHF1Z3NKZGJqSEY2NVZkUE1Ld1MwK1dRYy9NZ0t2cklPSHlzQjl2Z1B3azgrODVobVBiblFkdkhaeURNQUZEN0wzRU9wZ01jVmR2bkhGUzAvdmxhdHJYdkNWeDBVOWd0M2Z4dm5BMC9oQjRubVJKRW1TSkVtU0pFbVNKR21IZmdGTGFEUG9NdTV4V3dBQUFBQkpSVTVFcmtKZ2dnPT0i") 0 0 no-repeat !important;
    background-size: 264px 88px;
    width: 44px;
    height: 44px;
  }

  .pswp__button.pswp__button--arrow--right::before {
    background-image: url(/img/arrow_right.svg) !important;
    filter: invert(1);
    background-size: contain !important;
  }

  .pswp__button.pswp__button--arrow--left::before {
    background-image: url(/img/arrow_left.svg) !important;
    filter: invert(1);
    background-size: contain !important;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1200px) {
  .gallery_wrapper {
    width: 100%;
    padding-bottom: 0px;

    .my-gallery {
      figure {
        margin: 0;

        img {
          margin-bottom: 10px;
          margin-left: 10px;
        }
      }
    }
  }
}

@media screen and (max-width: 1199px) {
  .container-fluid {
    position: relative;
  }

  .top h3 {
    margin-top: 0 !important;
    margin-bottom: 20px;
  }

  .gallery_wrapper {
    width: 100%;
    padding-bottom: 0px;

    .pswp__scroll-wrap {
      position: absolute;
      left: 0;
      top: 66px;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    figure:not(:first-child) {
      display: none;
    }

    figure {
      float: none;

      img {
        margin: 0;
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
  }
}
</style>
